import { __awaiter, __generator } from 'tslib';
import { Injectable, defineInjectable } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var NgNavigatorShareService = /** @class */ (function () {
    function NgNavigatorShareService() {
        this.webNavigator = null;
        this.webNavigator = window.navigator;
    }
    /**
     * @param {?} __0
     * @return {?}
     */
    NgNavigatorShareService.prototype.share = /**
     * @param {?} __0
     * @return {?}
     */
    function (_a) {
        var _this = this;
        var title = _a.title, text = _a.text, url = _a.url;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var isShared, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.webNavigator !== null && this.webNavigator.share !== undefined)) return [3 /*break*/, 5];
                        if (!((text === undefined || text === null) &&
                            (url === undefined || url === null))) return [3 /*break*/, 1];
                        console.warn("text and url both can't be empty, at least provide either text or url");
                        return [3 /*break*/, 4];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.webNavigator.share({
                                title: title,
                                text: text,
                                url: url,
                            })];
                    case 2:
                        isShared = _a.sent();
                        resolve({
                            shared: true
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        reject({
                            shared: false,
                            error: error_1
                        });
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        reject({
                            shared: false,
                            error: "This service/api is not supported in your Browser"
                        });
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); });
    };
    NgNavigatorShareService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] },
    ];
    /** @nocollapse */
    NgNavigatorShareService.ctorParameters = function () { return []; };
    /** @nocollapse */ NgNavigatorShareService.ngInjectableDef = defineInjectable({ factory: function NgNavigatorShareService_Factory() { return new NgNavigatorShareService(); }, token: NgNavigatorShareService, providedIn: "root" });
    return NgNavigatorShareService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { NgNavigatorShareService };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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